import React, { useState } from "react";

import EditOrAddESI from "../EditOrAddESIModal/EditOrAddESI";
import { useGetEmployeeESIDetails } from "../../../queries/employeeQueries";
import { useSelector } from "react-redux";
import userRoleAuth from "../../../utils/userRoleAuth/userRoleAuth";
import userRoles from "../../../config/userRoles";
const EmployeeInsurance = ({ employee }) => {
  const [openModal, setOpenModel] = useState(false);
  const onOpenModal = () => setOpenModel(true);
  const onCloseModal = () => setOpenModel(false);
  const { data: esiData } = useGetEmployeeESIDetails({
    employee_id: employee?.employee_id,
  });

  const esiDetails = esiData?.data?.[0] || {};
  const loggedInUser = useSelector((state) => state.user.auth);
  const isHr = userRoleAuth(loggedInUser, userRoles.HR);
  const isAdmin = userRoleAuth(loggedInUser, userRoles.TENANTADMIN);

  const isFinanceAdmin = userRoleAuth(loggedInUser, userRoles.FINANCEADMIN);
  const isAdminOrHROrFinanceAdmin = isHr || isAdmin || isFinanceAdmin;
  return (
    <div className="bg-white px-8 py-6 rounded-md border border-gray-100 shadow-md shadow-[#F3F4F6] mt-6 mb-5">
      <div className="flex items-center justify-between pb-3">
      <div className="flex items-center gap-3">
        <img src="/images/basic-info-icon.svg" alt="" />
        <p className="text-base text-[#1F2937] font-semibold">
          Employees State Insurance (ESI)
        </p>
      </div>
      {isAdminOrHROrFinanceAdmin && (
        <div className="cursor-pointer">
          <img
            src="/images/editicon.svg"
            alt=""
            onClick={() => onOpenModal()}
          />
          <EditOrAddESI
            openModal={openModal}
            onCloseModal={onCloseModal}
            employee={{ ...employee, esiDetails }}
          />
        </div>
      )}
    </div>
  
    <div className="employee-info-card w-full">
      <table className="w-full border-0 table-fixed">
        <tbody>
       
          <tr className="align-top">
            <td className="title py-2 pr-4 min-w-[180px] text-gray-700 font-medium">
              ESI Insurance Number
            </td>
            <td className="data py-2">
              {esiDetails?.esi_number || "N/A"}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  
  );
};

export default EmployeeInsurance;
